(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 41240:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(34226);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 1 modules
var Button_Button = __webpack_require__(54225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(29620);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(77745);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(95398);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContentText/DialogContentText.js + 1 modules
var DialogContentText = __webpack_require__(44642);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(76779);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box_Box = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js
var Container = __webpack_require__(78016);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack_Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/Divider.js
var Divider_Divider = __webpack_require__(44373);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(51201);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CloseOutlined.js
var CloseOutlined = __webpack_require__(20518);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/accountdetails/copypaste/CopyToClipBoard.js
var CopyToClipBoard = __webpack_require__(32905);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Unstable_Grid2/Grid2.js + 2 modules
var Grid2 = __webpack_require__(95413);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/tokens.js
var src_tokens = __webpack_require__(5786);
;// CONCATENATED MODULE: ./src/components/homepage/Footer.js
/* eslint-disable no-unused-vars */ /* eslint-disable react/prop-types */ /* eslint-disable no-shadow */ 









var useMobileBreakpoint = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 600;
    var isDesktop = (0,useMediaQuery/* default */.Z)("(min-width:".concat(target, "px)"));
    return !isDesktop || lib/* isMobile */.tq;
};
function Copyright() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            " \xa9 ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "./about/blockquiry",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                    size: "small",
                    sx: {
                        textTransform: "none",
                        bgColor: "none"
                    },
                    children: [
                        "blockquiry ",
                        new Date().getFullYear(),
                        "."
                    ]
                })
            }),
            " "
        ]
    });
}
var Item = (0,styled/* default */.Z)(Box_Box/* default */.Z)(function() {
    return {
        px: 2,
        color: src_tokens/* tokens.token_typography_regular */.T.token_typography_regular,
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.775rem",
        fontWeight: 500,
        whiteSpace: "nowrap"
    };
});
function Footer() {
    var isMobile = useMobileBreakpoint(600);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        component: "footer",
        position: "fixed",
        bottom: 0,
        width: "100%",
        sx: {
            backgroundColor: src_tokens/* tokens.token_grey_100 */.T.token_grey_100,
            display: {
                xs: "none",
                md: "block"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid2/* default */.Z, {
            container: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                    xs: 6,
                    sm: 6,
                    md: 4,
                    lg: 4,
                    xl: 4,
                    sx: {
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        paddingLeft: 5,
                        paddingRight: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/about/blockquiry/howsearchworks",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            size: "small",
                            sx: {
                                textTransform: "none",
                                bgColor: "none"
                            },
                            children: "How Search Works"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                    xs: 6,
                    sm: 6,
                    md: 4,
                    lg: 4,
                    xl: 4,
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingLeft: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Copyright, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                    xs: 0,
                    sm: 0,
                    md: 4,
                    lg: 4,
                    xl: 4,
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        px: 5,
                        paddingRight: 5
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        sx: {
                            display: {
                                xs: "none",
                                sm: "none",
                                md: "block"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/about/blockquiry/privacy",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        size: "small",
                                        sx: {
                                            textTransform: "none",
                                            bgColor: "none"
                                        },
                                        children: "Privacy"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/about/blockquiry/terms",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        size: "small",
                                        sx: {
                                            textTransform: "none",
                                            bgColor: "none"
                                        },
                                        children: "Terms"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(85050);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Drawer/Drawer.js + 1 modules
var Drawer_Drawer = __webpack_require__(60684);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/List/List.js + 1 modules
var List = __webpack_require__(85214);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItem/ListItem.js + 3 modules
var ListItem = __webpack_require__(81284);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(95309);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemText/ListItemText.js
var ListItemText_ListItemText = __webpack_require__(61702);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Menu.js
var Menu = __webpack_require__(326);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(20784);
// EXTERNAL MODULE: ./src/components/layouts/searchlayout/utils/MonetizationButton.js + 1 modules
var MonetizationButton = __webpack_require__(4917);
// EXTERNAL MODULE: ./src/components/homepage/app-menu/AppMenu.js + 1 modules
var AppMenu = __webpack_require__(41768);
;// CONCATENATED MODULE: ./src/components/homepage/HomeAppBar.js
/* eslint-disable react/require-default-props */ /* eslint-disable no-undef */ /* eslint-disable react/prop-types */ /* eslint-disable no-unused-vars */ 




















var LinkButton = (0,styled/* default */.Z)(Button_Button/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.875rem",
        fontWeight: 600,
        textTransform: "none",
        color: src_tokens/* tokens.token_link_grey */.T.token_link_grey,
        lineHeight: "16.8px",
        display: "inline-block",
        textAlign: "left",
        paddingRight: "16px",
        marginTop: "10px"
    };
});
var LinkTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.675rem",
        letterSpacing: "0.0107142857em",
        fontWeight: 500,
        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
        // lineHeight: '0.775px',
        display: "block",
        textAlign: "left"
    };
});
var HomeAppBar_Item = (0,styled/* default */.Z)(Button_Button/* default */.Z)(function() {
    return {
        textTransform: "none",
        fontFamily: "Roboto,arial,sans-serif",
        opacity: 1,
        display: "inline-block",
        fontStretch: "100%",
        fontSize: "1.00rem",
        fontWeight: 500,
        fontStyle: "normal",
        textDecorationThickness: "auto",
        fontVariantCaps: "normal",
        lineHeight: "2.25rem",
        letterSpacing: "0rem",
        textAlign: "left",
        paddingLeft: 4,
        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
        "&:hover": {
            backgroundColor: src_tokens/* tokens.token_grey_100 */.T.token_grey_100
        }
    };
});
var MenuTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        textTransform: "none",
        fontFamily: "Roboto,arial,sans-serif",
        opacity: 1,
        display: "inline-block",
        fontStretch: "100%",
        fontSize: "1.00rem",
        fontWeight: 500,
        fontStyle: "normal",
        textDecorationThickness: "auto",
        fontVariantCaps: "normal",
        lineHeight: "1.25rem",
        letterSpacing: "0rem",
        textAlign: "left",
        paddingLeft: "20px",
        paddingRight: "20px",
        paddingTop: "12px",
        paddingBottom: "12px",
        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white
    };
});
var drawerWidth = 240;
var navItems = [
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/about/blockquiry/",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuTypo, {
                    children: "About"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/about/blockquiry/howsearchworks",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuTypo, {
                    children: "How Search Works"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/about/blockquiry/privacy",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuTypo, {
                    children: "Privacy"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/about/blockquiry/terms",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuTypo, {
                    children: "Terms"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "mailto:inquiries@blockquiry.com",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuTypo, {
                    children: "Contact"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/web/blockquiry",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuTypo, {
                    sx: {
                        paddingLeft: "35px"
                    },
                    children: "web.blockquiry"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/web/blockquiry",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuTypo, {
                    sx: {
                        paddingLeft: "35px"
                    },
                    children: "tor.blockquiry"
                })
            })
        ]
    }), 
];
function ColorText(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        style: {
            color: src_tokens/* tokens.palette_secondary */.T.palette_secondary
        },
        children: children
    });
}
var HomeAppBar_Search = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return {
        border: "1px solid",
        borderColor: src_tokens/* tokens.token_search_border_grey */.T.token_search_border_grey,
        borderRadius: 24,
        maxHeight: 50,
        display: "flex",
        alignItems: "center",
        shadows: 2,
        "&:hover": {
            shadows: 2
        }
    };
});
function HomeAppBar(props) {
    var searchInputRef = (0,react.useRef)(null);
    // const { data: session } = useSession();
    var router = (0,next_router.useRouter)();
    var ref = (0,next_router.useRouter)(), push = ref.push, asPath = ref.asPath;
    var handleClick = function() {
        console.log("MonetizationButton clicked");
    // add other functionality 
    };
    // const handleSignOut = () => signOut({ redirect: false });
    // const handleSingIn = () => push(`/auth/signin?callbackUrl=${asPath}`);
    var search = function(e) {
        e.preventDefault();
        var term = searchInputRef.current.value;
        if (!term) return;
        router.push("/search?term=".concat(term));
    };
    var window = props.window;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), mobileOpen = ref1[0], setMobileOpen = ref1[1];
    var handleDrawerToggle = function() {
        setMobileOpen(!mobileOpen);
    };
    var drawer = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        onClick: handleDrawerToggle,
        sx: {
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                component: "a",
                href: "",
                sx: {
                    my: 2,
                    display: {
                        xs: "block",
                        sm: "none"
                    },
                    flexGrow: 1,
                    fontFamily: "play",
                    fontWeight: 700,
                    color: src_tokens/* tokens.palette_primary */.T.palette_primary,
                    textDecoration: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorText, {
                        children: "b"
                    }),
                    "lockquiry"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                children: navItems.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                        disablePadding: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemButton/* default */.Z, {
                            sx: {
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_ListItemText/* default */.Z, {
                                primary: item
                            })
                        })
                    }, item);
                })
            })
        ]
    });
    var container = window !== undefined ? function() {
        return window().document.body;
    } : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        sx: {
            mt: 2,
            display: "flex"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBar/* default */.Z, {
                component: "nav",
                position: "sticky",
                elevation: 0,
                sx: {
                    backgroundColor: src_tokens/* tokens.token_surface */.T.token_surface
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                "aria-label": "open drawer",
                                edge: "start",
                                onClick: handleDrawerToggle,
                                sx: {
                                    mx: "auto",
                                    display: {
                                        sm: "none"
                                    },
                                    color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    display: {
                                        xs: "none",
                                        sm: "block"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/about/blockquiry",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton, {
                                        children: "About"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    minWidth: "60px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMenu/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    minWidth: "60px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MonetizationButton/* default */.Z, {
                                    router: router,
                                    onClick: handleClick
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        mx: "16px",
                        sx: {
                            flexGrow: 1,
                            display: {
                                xs: "block",
                                sm: "none"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        maxWidth: "650px",
                        maxHeight: "48px",
                        flexDirection: "row",
                        sx: {
                            ml: {
                                xs: -2,
                                sm: "96px"
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                component: "nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer_Drawer/* default */.ZP, {
                    container: container,
                    variant: "temporary",
                    open: mobileOpen,
                    onClose: handleDrawerToggle,
                    ModalProps: {
                        keepMounted: true
                    },
                    sx: {
                        display: {
                            xs: "block",
                            sm: "none"
                        },
                        "& .MuiDrawer-paper": {
                            boxSizing: "border-box",
                            width: drawerWidth
                        }
                    },
                    children: drawer
                })
            })
        ]
    });
}
HomeAppBar.propTypes = {
    /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */ window: (prop_types_default()).func
};
/* harmony default export */ var homepage_HomeAppBar = (HomeAppBar);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Link/Link.js + 2 modules
var Link = __webpack_require__(68346);
;// CONCATENATED MODULE: ./src/components/follow-the-money/graph/graph-main/components/NodeInfoCardMobile.js





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-top: 16px;\n  margin-left: 16px;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 15px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 6px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var SectionHead = (0,styled/* default */.Z)(function(_param) /*#__PURE__*/ {
    var props = (0,_extends/* default */.Z)({}, _param);
    return (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        component: "div"
    }, props));
})(_templateObject(), src_tokens/* tokens.token_typography_subhead */.T.token_typography_subhead);
var SectionDivider = (0,styled/* default */.Z)(Divider_Divider/* default */.Z)(_templateObject1());
var SubSectionHead = (0,styled/* default */.Z)(function(_param) /*#__PURE__*/ {
    var props = (0,_extends/* default */.Z)({}, _param);
    return (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        component: "div",
        variant: "h6"
    }, props));
})(_templateObject2(), src_tokens/* tokens.token_grey_800 */.T.token_grey_800);
var VerticalSeparator = (0,styled/* default */.Z)(Box_Box/* default */.Z)(_templateObject3());
var ItemText = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "0.775rem",
        fontWeight: 500,
        lineHeight: "1.50rem",
        letterSpacing: "0.01071em",
        color: src_tokens/* tokens.token_typography_emphasized */.T.token_typography_emphasized,
        marginRight: "8px"
    };
});
var AttributeText = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "0.775rem",
        fontWeight: 400,
        lineHeight: "1.50rem",
        letterSpacing: "0.01071em",
        color: src_tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white
    };
});
var IconText = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "0.575rem",
        fontWeight: 500,
        color: src_tokens/* tokens.palette_primary */.T.palette_primary,
        "&:hover": {
            color: src_tokens/* tokens.palette_secondary */.T.palette_secondary
        }
    };
});
var StyledIcon = (0,styled/* default */.Z)(IconButton/* default */.Z)(function() {
    return {
        paddingTop: "2px",
        paddingBottom: "2px",
        height: "18px",
        width: "18px",
        color: src_tokens/* tokens.palette_primary */.T.palette_primary,
        "&:hover": {
            color: src_tokens/* tokens.palette_secondary */.T.palette_secondary
        }
    };
});
var StyledLink = (0,styled/* default */.Z)(Link/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "0.685rem",
        fontWeight: 500,
        color: src_tokens/* tokens.token_blue_700 */.T.token_blue_700
    };
});
function TemporaryDrawer() {
    var ref = useState({
        bottom: false
    }), state = ref[0], setState = ref[1];
    var toggleDrawer = function(anchor, open) {
        return function(event) {
            if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
                return;
            }
            setState(_object_spread_props(_object_spread({}, state), _define_property({}, anchor, open)));
        };
    };
    var list = function(anchor) {
        return /*#__PURE__*/ _jsx(Box, {
            sx: {
                width: "auto",
                display: {
                    sx: "block",
                    md: "none"
                },
                justifyContent: "center",
                alignItems: "center"
            },
            role: "presentation",
            onClick: toggleDrawer(anchor, false),
            onKeyDown: toggleDrawer(anchor, false),
            children: /*#__PURE__*/ _jsxs(Paper, {
                // variant="outlined"
                elevation: 0,
                sx: {
                    px: "8px",
                    py: "8px"
                },
                children: [
                    /*#__PURE__*/ _jsx(SectionHead, {
                        children: "Address Attribution"
                    }),
                    /*#__PURE__*/ _jsx(Divider, {
                        sx: {
                            "&.MuiDivider-root": {
                                my: "4px",
                                mx: "8px"
                            }
                        }
                    }),
                    /*#__PURE__*/ _jsxs(MenuList, {
                        dense: true,
                        children: [
                            /*#__PURE__*/ _jsx(MenuItem, {
                                children: /*#__PURE__*/ _jsxs(ListItemText, {
                                    children: [
                                        /*#__PURE__*/ _jsx(ItemText, {
                                            display: "inline",
                                            children: "Attribution:"
                                        }),
                                        /*#__PURE__*/ _jsx(AttributeText, {
                                            display: "inline",
                                            children: "KuCoin"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                children: /*#__PURE__*/ _jsxs(ListItemText, {
                                    children: [
                                        /*#__PURE__*/ _jsx(ItemText, {
                                            display: "inline",
                                            children: "Attribution By:"
                                        }),
                                        /*#__PURE__*/ _jsx(StyledLink, {
                                            display: "inline",
                                            children: "blockquiry"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                children: /*#__PURE__*/ _jsxs(ListItemText, {
                                    children: [
                                        /*#__PURE__*/ _jsx(ItemText, {
                                            display: "inline",
                                            children: "Label:"
                                        }),
                                        /*#__PURE__*/ _jsx(AttributeText, {
                                            display: "inline",
                                            children: "Exchange"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                children: /*#__PURE__*/ _jsxs(ListItemText, {
                                    children: [
                                        /*#__PURE__*/ _jsx(ItemText, {
                                            display: "inline",
                                            children: "Type:"
                                        }),
                                        /*#__PURE__*/ _jsx(AttributeText, {
                                            display: "inline",
                                            children: "Centralized"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                children: /*#__PURE__*/ _jsxs(ListItemText, {
                                    children: [
                                        /*#__PURE__*/ _jsx(ItemText, {
                                            display: "inline",
                                            children: "Country:"
                                        }),
                                        /*#__PURE__*/ _jsx(AttributeText, {
                                            display: "inline",
                                            children: "Seychelles"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Divider, {
                                sx: {
                                    "&.MuiDivider-root": {
                                        my: "4px",
                                        mx: "8px"
                                    }
                                }
                            }),
                            /*#__PURE__*/ _jsx(SectionHead, {
                                children: "Contact Information and Policies"
                            }),
                            /*#__PURE__*/ _jsx(Divider, {
                                sx: {
                                    "&.MuiDivider-root": {
                                        my: "4px",
                                        mx: "8px"
                                    }
                                }
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                children: /*#__PURE__*/ _jsx(ListItemText, {
                                    disableGutters: true,
                                    children: /*#__PURE__*/ _jsxs(Stack, {
                                        direction: "row",
                                        spacing: 1,
                                        sx: {
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsxs(Stack, {
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ _jsx(StyledIcon, {
                                                        children: /*#__PURE__*/ _jsx(TwitterIcon, {
                                                            fontSize: "small"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(IconText, {
                                                        variant: "caption",
                                                        children: "Twitter"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Stack, {
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ _jsx(StyledIcon, {
                                                        children: /*#__PURE__*/ _jsx(EmailOutlinedIcon, {
                                                            fontSize: "small"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(IconText, {
                                                        variant: "caption",
                                                        children: "Email"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Stack, {
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ _jsx(StyledIcon, {
                                                        children: /*#__PURE__*/ _jsx(LanguageOutlinedIcon, {
                                                            fontSize: "small"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(IconText, {
                                                        variant: "caption",
                                                        children: "Web"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Stack, {
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ _jsx(StyledIcon, {
                                                        children: /*#__PURE__*/ _jsx(PolicyOutlinedIcon, {
                                                            fontSize: "small"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(IconText, {
                                                        variant: "caption",
                                                        children: "Privacy"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Stack, {
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ _jsx(StyledIcon, {
                                                        children: /*#__PURE__*/ _jsx(GavelOutlinedIcon, {
                                                            fontSize: "small"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx(IconText, {
                                                        variant: "caption",
                                                        children: "Terms"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(Divider, {
                                sx: {
                                    "&.MuiDivider-root": {
                                        my: "4px",
                                        mx: "8px"
                                    }
                                }
                            }),
                            /*#__PURE__*/ _jsx(SectionHead, {
                                children: "Regional Regulation and Legislation"
                            }),
                            /*#__PURE__*/ _jsx(Divider, {
                                sx: {
                                    "&.MuiDivider-root": {
                                        my: "4px",
                                        mx: "8px"
                                    }
                                }
                            }),
                            /*#__PURE__*/ _jsxs(Stack, {
                                direction: "row",
                                spacing: 2,
                                sx: {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    px: "16px"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(StyledLink, {
                                        children: "Regulation"
                                    }),
                                    /*#__PURE__*/ _jsx(StyledLink, {
                                        href: "/",
                                        underline: "hover",
                                        target: "_blank",
                                        children: "Agencies"
                                    }),
                                    /*#__PURE__*/ _jsx(StyledLink, {
                                        href: "/",
                                        underline: "hover",
                                        target: "_blank",
                                        children: "Legislation"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(Button, {
                onClick: toggleDrawer("bottom", true),
                children: "Open from Bottom"
            }),
            /*#__PURE__*/ _jsx(Drawer, {
                anchor: "bottom",
                open: state.bottom,
                onClose: toggleDrawer("bottom", false),
                sx: {
                    borderRadius: "6px"
                },
                children: list("bottom")
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/index.js
/* eslint-disable react/no-danger */ /* eslint-disable @next/next/no-script-component-in-head */ /* eslint-disable @next/next/inline-script-id */ /* eslint-disable import/no-unresolved */ /* eslint-disable react/prop-types */ /* eslint-disable no-unused-vars */ /* eslint-disable react/jsx-filename-extension */ 














// import { getSession } from 'next-auth/client';




// eslint-disable-next-line no-empty-pattern
function pages_ColorText(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("span", {
        style: {
            color: tokens.palette_secondary
        },
        children: children
    });
}
var BlockTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "play",
        opacity: 1,
        fontSize: "1.00rem",
        fontWeight: 700,
        lineHeight: "1.25rem",
        textAlign: "center",
        paddingLeft: 0,
        whiteSpace: "wrap",
        color: src_tokens/* tokens.palette_primary */.T.palette_primary
    };
});
var pages_Search = (0,styled/* default */.Z)("div")(function() {
    return {
        border: "1px solid",
        borderColor: src_tokens/* tokens.token_search_border_grey */.T.token_search_border_grey,
        borderRadius: 24,
        maxHeight: 50,
        display: "flex",
        alignItems: "center",
        shadows: 2,
        "&:hover": {
            shadows: 2
        }
    };
});
var SearchButton = (0,styled/* default */.Z)(Button_Button/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.8750em",
        fontWeight: 500,
        textTransform: "none",
        color: src_tokens/* tokens.token_typography_regular_emphasized */.T.token_typography_regular_emphasized,
        border: "1px, solid",
        borderColor: src_tokens/* tokens.token_grey_50 */.T.token_grey_50,
        backgroundColor: src_tokens/* tokens.token_grey_50 */.T.token_grey_50,
        "&:hover,&:focus": {
            border: "1px solid",
            borderColor: src_tokens/* tokens.token_grey_300 */.T.token_grey_300,
            boxShadow: "0px 1px 1px rgb(0 0 0 / 10%)"
        }
    };
});
var WebTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "play",
        opacity: 1,
        fontSize: "1.25rem",
        fontStyle: "italic",
        fontWeight: 700,
        lineHeight: "1.50rem",
        textAlign: "unset",
        paddingLeft: 0,
        whiteSpace: "nowrap",
        color: src_tokens/* tokens.palette_secondary */.T.palette_secondary
    };
});
var TryItTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,sans-serif",
        fontSize: "small",
        fontWeight: 500,
        color: src_tokens/* tokens.token_typography_headline */.T.token_typography_headline,
        textDecoration: "solid",
        textDecorationThickness: "auto",
        cursor: "pointer"
    };
});
var TryItColorTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,sans-serif",
        fontSize: "small",
        fontWeight: 500,
        color: src_tokens/* tokens.token_typography_results_link */.T.token_typography_results_link,
        textDecoration: "solid",
        textDecorationThickness: "auto",
        cursor: "pointer"
    };
});
var MessageTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,sans-serif",
        fontSize: "13px",
        color: src_tokens/* tokens.token_typography_results_link */.T.token_typography_results_link,
        textDecoration: "solid",
        textDecorationThickness: "auto",
        cursor: "pointer"
    };
});
function SimpleDialog(props) {
    var ref = (0,react.useState)(true), open = ref[0], setOpen = ref[1];
    var handleClose = function() {
        setOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        open: open,
        onClose: handleClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                id: "alert-dialog-title",
                children: "Hello there! "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContentText/* default */.Z, {
                        id: "alert-dialog-description",
                        children: "Thanks for joining us on this journey! As we polish the gears of our blockquiry platform, a hiccup or two might surface. Curious about our big picture? Swing by our About page. Stay patient, stay excited – together, we're crafting a digital world that's safer by design!"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    onClick: handleClose,
                    children: "Close"
                })
            })
        ]
    });
}
var testAddress = "0x96a08aceb70380777c51dfeea379bd33be1ab167";
function Home(param) {
    var session = param.session;
    var router = (0,next_router.useRouter)();
    var searchInputRef = (0,react.useRef)(null);
    var search = function(e) {
        e.preventDefault();
        var term = searchInputRef.current.value;
        if (!term) return;
        router.push("/search?term=".concat(term));
    // router.push(`/search?term=${term}`).then(() => router.reload());
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "blockquiry | Simplest way to get involved in the blockchain economy."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Tools to make cryptocurrency interactions safe, familiar, and uncomplicated."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "block explorer, bitcoin explorer, blockchain explorer, transaction search, bitcoin address, digital currency, ethereum address, ether, ethereum blockchain, ethereum transaction, visualize blockchain transactions, report crypto crime, crypto scam alert, ethereum explorer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "blockquiry"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "blockquiry | Simplest way to get involved in the blockchain economy."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:description",
                        content: "Tools to make cryptocurrency interactions safe, familiar, and uncomplicated."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "/blockquiry92x21.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "http://schema.org",
                                "@type": "WebSite",
                                name: "blockquiry",
                                description: "A search engine for finding information, about blockchain transactions, entities conducting business using the blockchain and the government agencies regulating them.",
                                image: "https://www.blockquiry.com/blockquiry_homepage.png",
                                url: "https://www.blockquiry.com/",
                                potentialAction: {
                                    "@type": "SearchAction",
                                    target: "https://www.blockquiry.com/search?q={search_term_string}",
                                    "query-input": "required name=search_term_string"
                                },
                                author: {
                                    "@type": "Organization",
                                    name: "blockquiry, LLC."
                                },
                                publisher: {
                                    "@type": "Organization",
                                    name: "blockquiry, LLC.",
                                    logo: {
                                        "@type": "ImageObject",
                                        url: "https://www.blockquiry.com/_next/image?url=%2Fblockquiry272x64.png&w=384&q=75",
                                        width: 272,
                                        height: 64
                                    }
                                },
                                dateModified: "2022-12-11",
                                datePublished: "2020-03-01"
                            })
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_HomeAppBar, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                disableGutters: true,
                maxWidth: "sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            mt: "170px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 272,
                                height: 64,
                                src: "/blockquiry272x64.png",
                                alt: "logo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "flex-start"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                sx: {
                                    flexGrow: 1,
                                    paddingTop: "20px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    m: 1,
                                    maxWidth: "584px",
                                    flexDirection: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(pages_Search, {
                                        sx: {
                                            boxShadow: 0,
                                            "&:hover": {
                                                boxShadow: "1px 1px 6px rgb(32 33 36 / 28%)"
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                onClick: search,
                                                type: "submit",
                                                sx: {
                                                    p: "10px",
                                                    color: src_tokens/* tokens.palette_primary */.T.palette_primary
                                                },
                                                "aria-label": "search",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                // disabled
                                                style: {
                                                    width: "100%",
                                                    height: "35px",
                                                    border: "none",
                                                    outline: "none",
                                                    fontFamily: "Roboto",
                                                    fontSize: "0.85rem",
                                                    fontWeight: "500"
                                                },
                                                ref: searchInputRef,
                                                type: "text",
                                                placeholder: "Search a BTC or ETH address"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {
                                                sx: {
                                                    height: 28,
                                                    m: 0.5
                                                },
                                                orientation: "vertical"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                onClick: function() {
                                                    if (searchInputRef.current) {
                                                        searchInputRef.current.value = "";
                                                    }
                                                },
                                                sx: {
                                                    p: "10px",
                                                    color: src_tokens/* tokens.palette_secondary */.T.palette_secondary
                                                },
                                                "aria-label": "directions",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {})
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                paddingTop: "18px",
                                direction: "row",
                                spacing: 1,
                                justifyContent: "center",
                                maxWidth: "584px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {
                                        type: "submit",
                                        onClick: search,
                                        children: "Block Search"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {
                                            disabled: true,
                                            type: "submit",
                                            onClick: function() {
                                                return window.open("/advanced_search", "_blank");
                                            },
                                            children: "Advanced Search"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleDialog, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        maxWidth: "584px",
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                            mt: "30px",
                            mx: "20px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                            sx: {
                                maxWidth: "300px",
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                                marginTop: "20px",
                                padding: "5px"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
}


/***/ }),

/***/ 32905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80562);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17155);
/* harmony import */ var _mui_icons_material_ContentCopyOutlined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46441);
/* harmony import */ var _tokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5786);
/* eslint-disable react/prop-types */ 




function CopyToClipboard(param) {
    var stringToCopy = param.stringToCopy;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    var handleClick = function() {
        setOpen(true);
        navigator.clipboard.writeText(stringToCopy);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                onClick: handleClick,
                color: "primary",
                style: {
                    padding: "1px",
                    marginLeft: "4px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ContentCopyOutlined__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    sx: {
                        color: _tokens__WEBPACK_IMPORTED_MODULE_2__/* .tokens.token_grey_500 */ .T.token_grey_500,
                        height: "14px",
                        width: "14px"
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                message: "Copied to clipboard",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                autoHideDuration: 800,
                onClose: function() {
                    return setOpen(false);
                },
                open: open,
                sx: {
                    backgroundColor: _tokens__WEBPACK_IMPORTED_MODULE_2__/* .tokens.token_grey_300 */ .T.token_grey_300
                }
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CopyToClipboard);


/***/ }),

/***/ 41768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ app_menu_AppMenu; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Menu/Menu.js + 3 modules
var Menu = __webpack_require__(73812);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 28 modules
var makeStyles = __webpack_require__(77338);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Apps.js
var Apps = __webpack_require__(94492);
// EXTERNAL MODULE: ./src/tokens.js
var tokens = __webpack_require__(5786);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./src/components/layouts/searchlayout/utils/ChatButton.js
var ChatButton = __webpack_require__(36067);
// EXTERNAL MODULE: ./src/components/layouts/searchlayout/utils/MessageButton.js
var MessageButton = __webpack_require__(95162);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/OutlinedFlag.js
var OutlinedFlag = __webpack_require__(26981);
;// CONCATENATED MODULE: ./src/components/layouts/searchlayout/utils/ReportButton.js







var IconText = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "0.575rem",
        fontWeight: 500,
        color: tokens/* tokens.palette_primary */.T.palette_primary
    };
});
var StyledIcon = (0,styled/* default */.Z)(Box/* default */.Z)(function() {
    return {
        paddingTop: "2px",
        paddingBottom: "2px",
        marginBottom: "4px",
        height: "18px",
        width: "18px",
        color: tokens/* tokens.token_red_typography */.T.token_red_typography,
        "&:hover": {
            color: tokens/* tokens.palette_secondary */.T.palette_secondary
        }
    };
});
var TriggerButton = (0,styled/* default */.Z)("button")(function(param) {
    var theme = param.theme;
    return "\n  font-family: IBM Plex Sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 600;\n  box-sizing: border-box;\n  min-height: calc(1.5em + 22px);\n  border-radius: 12px;\n  padding: 6px 12px;\n  line-height: 1.5;\n  background: transparent;\n  border: 1px solid transparent;\n  color: ".concat(tokens/* tokens.token_grey_100 */.T.token_grey_100, ";\n  &:hover {\n    background: ").concat(tokens/* tokens.token_grey_10 */.T.token_grey_10, ";\n    border-color: ").concat(tokens/* tokens.token_grey_300 */.T.token_grey_300, ";\n  }\n  &:focus-visible {\n    border-color: ").concat(tokens/* tokens.token_blue_500 */.T.token_blue_500, ";\n    outline: 3px solid ").concat(tokens/* tokens.token_blue_200 */.T.token_blue_200, ";\n  }\n  ");
});
function ReportButton_MessageButton() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TriggerButton, {
            disabled: true,
            "aria-label": "message",
            onClick: function() {
                return router.push("/blockquiry_connect/u/select_agency");
            },
            sx: {
                "&:hover": {
                    color: tokens/* tokens.palette_secondary */.T.palette_secondary
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlinedFlag/* default */.Z, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconText, {
                        variant: "caption",
                        children: "Report"
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/homepage/app-menu/AppMenu.js








// import ReportDialog from '../../accountdetails/reportcryptocrime/ReportDialog';



var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        iconButton: {
            padding: theme.spacing(0.5)
        },
        icon: {
            marginBottom: theme.spacing(0.5)
        }
    };
});
var AppMenu_IconText = (0,styled/* default */.Z)("div")({
    fontFamily: "Roboto, Arial, sans-serif",
    fontSize: "0.675rem",
    letterSpacing: "0.0107142857em",
    fontWeight: 500,
    color: tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
    lineHeight: "0.875rem",
    display: "flex",
    justifyContent: "center"
});
function AppMenu() {
    var router = (0,next_router.useRouter)();
    var ref = (0,next_router.useRouter)(), push = ref.push, asPath = ref.asPath;
    var ref1 = (0,react.useState)(null), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var classes = useStyles();
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                // disabled
                "aria-controls": "menu",
                "aria-haspopup": "true",
                onClick: handleClick,
                sx: {
                    color: tokens/* tokens.palette_primary */.T.palette_primary,
                    margin: "4px",
                    "&.MuiButtonBase-root.MuiIconButton-root:hover": {
                        borderRadius: "8px",
                        padding: "8px",
                        backgroundColor: tokens/* tokens.token_hairline */.T.token_hairline
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Apps/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                id: "menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        // my: { xs: '4px', md: '4px' },
                        // mx: { xs: '4px', md: '4px' },
                        p: {
                            xs: "4px",
                            md: "4px"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        direction: "row",
                        spacing: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatButton/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportButton_MessageButton, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageButton/* default */.Z, {})
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var app_menu_AppMenu = (AppMenu);


/***/ }),

/***/ 36067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChatButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30120);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9144);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13264);
/* harmony import */ var _mui_icons_material_MarkChatReadOutlined__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47695);
/* harmony import */ var _tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5786);







var IconText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "0.575rem",
        fontWeight: 500,
        color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary
    };
});
var StyledIcon = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
    return {
        paddingTop: "2px",
        paddingBottom: "2px",
        marginBottom: "4px",
        height: "18px",
        width: "18px",
        color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary,
        "&:hover": {
            color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_secondary */ .T.palette_secondary
        }
    };
});
var TriggerButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button")(function(param) {
    var theme = param.theme;
    return "\n  font-family: IBM Plex Sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 600;\n  box-sizing: border-box;\n  min-height: calc(1.5em + 22px);\n  border-radius: 12px;\n  padding: 6px 12px;\n  line-height: 1.5;\n  background: transparent;\n  border: 1px solid transparent;\n  color: ".concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_100 */ .T.token_grey_100, ";\n  &:hover {\n    background: ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_10 */ .T.token_grey_10, ";\n    border-color: ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_300 */ .T.token_grey_300, ";\n  }\n  &:focus-visible {\n    border-color: ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_blue_500 */ .T.token_blue_500, ";\n    outline: 3px solid ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_blue_200 */ .T.token_blue_200, ";\n  }\n  ");
});
function ChatButton() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TriggerButton, {
            // disabled
            "aria-label": "b_chat",
            onClick: function() {
                return router.push("/blockquiry_chat");
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_MarkChatReadOutlined__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            fontSize: "small",
                            sx: {
                                color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_secondary */ .T.palette_secondary
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconText, {
                        variant: "caption",
                        children: "ChatBot"
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 95162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MessageButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30120);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9144);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13264);
/* harmony import */ var _mui_icons_material_ThreePOutlined__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84512);
/* harmony import */ var _tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5786);







var IconText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "0.575rem",
        fontWeight: 500,
        color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary
    };
});
var StyledIcon = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
    return {
        paddingTop: "2px",
        paddingBottom: "2px",
        marginBottom: "4px",
        height: "18px",
        width: "18px",
        color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary,
        "&:hover": {
            color: _tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_secondary */ .T.palette_secondary
        }
    };
});
var TriggerButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button")(function(param) {
    var theme = param.theme;
    return "\n  font-family: IBM Plex Sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 600;\n  box-sizing: border-box;\n  min-height: calc(1.5em + 22px);\n  border-radius: 12px;\n  padding: 6px 12px;\n  line-height: 1.5;\n  background: transparent;\n  border: 1px solid transparent;\n  color: ".concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_100 */ .T.token_grey_100, ";\n  &:hover {\n    background: ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_10 */ .T.token_grey_10, ";\n    border-color: ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_300 */ .T.token_grey_300, ";\n  }\n  &:focus-visible {\n    border-color: ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_blue_500 */ .T.token_blue_500, ";\n    outline: 3px solid ").concat(_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_blue_200 */ .T.token_blue_200, ";\n  }\n  ");
});
function MessageButton() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TriggerButton, {
            disabled: true,
            "aria-label": "message",
            onClick: function() {
                return router.push("/blockquiry_connect/u/select_agency");
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ThreePOutlined__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconText, {
                        variant: "caption",
                        children: "Messages"
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 4917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MonetizationButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(17575);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/tooltipClasses.js
var tooltipClasses = __webpack_require__(32046);
;// CONCATENATED MODULE: ./src/components/layouts/searchlayout/utils/LightTooltip.js
/* eslint-disable import/no-relative-packages */ 






var LightTooltip = (0,styled/* default */.ZP)(function(props) {
    var className = props.className, otherProps = (0,_object_without_properties/* default */.Z)(props, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        classes: {
            popper: className
        }
    }));
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({}, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: theme.palette.common.white,
        color: "rgba(0, 0, 0, 0.87)",
        boxShadow: theme.shadows[1],
        fontSize: 11
    });
});
/* harmony default export */ var utils_LightTooltip = (LightTooltip);

// EXTERNAL MODULE: ./src/tokens.js
var tokens = __webpack_require__(5786);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PowerSettingsNewOutlined.js
var PowerSettingsNewOutlined = __webpack_require__(74808);
;// CONCATENATED MODULE: ./src/components/layouts/searchlayout/utils/MonetizationButton.js










function MonetizationButton(param) {
    var router = param.router, onClick = param.onClick;
    var ref = (0,react.useState)(false), clicked = ref[0], setClicked = ref[1];
    var handleClick = function() {
        setClicked(!clicked);
        // add micro payment function  when the button is clicked
        if (onClick) {
            onClick();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_LightTooltip, {
        title: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                //   disabled
                "aria-label": "money-button",
                onClick: handleClick,
                sx: {
                    margin: "4px",
                    "&.MuiButtonBase-root.MuiIconButton-root:hover": {
                        borderRadius: "8px",
                        padding: "8px",
                        backgroundColor: tokens/* tokens.token_hairline */.T.token_hairline
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    variant: "rounded",
                    sx: {
                        bgcolor: "transparent",
                        border: "1px solid",
                        borderColor: clicked ? tokens/* tokens.token_green_600 */.T.token_green_600 : tokens/* tokens.token_grey_300 */.T.token_grey_300,
                        width: "24px",
                        height: "24px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PowerSettingsNewOutlined/* default */.Z, {
                        sx: {
                            color: clicked ? tokens/* tokens.token_green_600 */.T.token_green_600 : tokens/* tokens.token_grey_300 */.T.token_grey_300,
                            width: "20px",
                            height: "20px"
                        }
                    })
                })
            })
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3517,4540,3835,1816,5426,517,2390,3408,247,7575,8653,4951,7155,5675,2615,3320,9774,2888,179], function() { return __webpack_exec__(41240); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);